export const ADD_ALERT_MESSAGE = "ADD_ALERT_MESSAGE";
export const REMOVE_ALERT_MESSAGE = "REMOVE_ALERT_MESSAGE";
export const CLEAR_ALERT_MESSAGE = "CLEAR_ALERT_MESSAGE";

export const GET_ORDERS_SEARCH_DATE = "GET_ORDERS_SEARCH_DATE";
export const SET_ORDERS_SEARCH_DATE = "SET_ORDERS_SEARCH_DATE";
export const GET_STORE_ORDERS_SEARCH_DATE = "GET_STORE_ORDERS_SEARCH_DATE";
export const SET_STORE_ORDERS_SEARCH_DATE = "SET_STORE_ORDERS_SEARCH_DATE";
